import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=c9a2e2d6&scoped=true&"
import script from "./CommentsList.vue?vue&type=script&lang=js&"
export * from "./CommentsList.vue?vue&type=script&lang=js&"
import style0 from "./CommentsList.vue?vue&type=style&index=0&id=c9a2e2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a2e2d6",
  null
  
)

export default component.exports